import {
  UNDEFINED_STATUS
} from './action-status';

import {
  UNDEFINED_VERIFY_STATUS
} from './verify-status';

export default function initialState() {
  return {
    moduleName: 'wr-notary-certificate',
    crtInternalId: '',
    fetchNotaryCertificateStatus: UNDEFINED_STATUS,
    calculateMerkleRootStatus: UNDEFINED_STATUS,
    merkleTreeRoot: '',
    jsonId: '',
    crtHashRoot: '',
    validateHashStatus: UNDEFINED_VERIFY_STATUS,
    validateMerkleStatus: UNDEFINED_VERIFY_STATUS,
    calculateCrtIdStatus: UNDEFINED_STATUS,
    calculatedCrtId: '',
    itemHash: '',
    hashList: [],
    merkleProof: [],
    hashRoot: '',
    merkleRoot: '',
    etheriumTransactionId: '',
    displayFileName: '',
    crtDate: '',
    crtSignee: '',
    splItemHash: ''
  };
}
